import { GraphQL } from '@guestgoodie/graphql'

export function cleanCaptions(captions: GraphQL.Caption[]): GraphQL.Caption[] {
  return captions.filter(caption => !!caption.text.trim())
}
